var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChair = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.9 19.9v15.6h-1.4V20.4M28.9 20.4v15.1h-1.4V19.9M14.4 12.8v4.7M27 12.8v4.7M29.9 19.4c0 .3-.2.5-.5.5H12c-.3 0-.5-.2-.5-.5V18c0-.3.2-.5.5-.5h17.4c.3 0 .5.2.5.5zM28.4 10.8c0 1.1-.9 1.9-1.9 1.9H14.9c-1.1.1-1.9-.8-1.9-1.9V7.4c0-1.1.9-1.9 1.9-1.9h11.6c1.1 0 1.9.9 1.9 1.9zM13.9 23.3h13.6"
}))));
export default SvgChair;